
import { ReviewFormValues } from '@/types/review';

// Calculate an overall rating based on individual ratings
export const calculateOverallRating = (values: ReviewFormValues): number => {
  // Get all the numeric ratings (excluding nulls)
  const ratings = [
    values.clarity_rating,
    values.technical_rigor_rating,
    values.novelty_rating,
    values.experimental_quality_rating,
    values.relevance_rating,
    values.impact_rating,
    values.prior_work_rating
  ].filter(rating => rating !== null && rating !== undefined) as number[];
  
  // If no ratings provided, return null
  if (ratings.length === 0) return 0;
  
  // Calculate average and round to 1 decimal place
  const sum = ratings.reduce((acc, val) => acc + val, 0);
  return Number((sum / ratings.length).toFixed(1));
};

// Convert recommendation to display text
export const getReviewRecommendationText = (recommendation: string | null | undefined): string => {
  switch(recommendation) {
    case 'accept':
      return 'Accept';
    case 'minor_revisions':
      return 'Minor Revisions';
    case 'major_revisions':
      return 'Major Revisions';
    case 'reject':
      return 'Reject';
    default:
      return 'No Recommendation';
  }
};
